import Settings from 'configs/Settings';
import MembershipService from 'modules/membership/MembershipService';

import AuthService from './AuthService';

import Request from '@hotmart/request';

const options = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
};

Request.register(Settings.api.oauth, {
  get: {
    'auth.token.check': '/check_token?token=:access_token',
    'auth.logout': '/logout'
  },
  post: {
    'auth.login': {
      path: '/token?grant_type=password&username=:username&password=:password',
      options
    },
    'auth.token.refresh': {
      path: '/token?grant_type=refresh_token&refresh_token=:refresh_token',
      options
    }
  }
});

Request.register(`${Settings.api.clubSec}/rest/v3/user`, {
  get: {
    'oauth.redirect.admin': '/redirect/clubAdmin'
  }
});

Request.register(Settings.api.clubUser, {
  get: {
    'auth.resources': '/v4/users/resources'
  }
});

const { token } = AuthService;
const { subdomain } = MembershipService || {};

Request.setDefaultHeaders({ token, Club: subdomain });
